import React, { useState, useEffect } from "react"
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress,
} from "@mui/material"
import { getRestaurants } from "helpers/api"

export const RestaurantSelector = ({ onSelectRestaurant }) => {
  const [restaurants, setRestaurants] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedRestaurant, setSelectedRestaurant] = useState("")

  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        const data = await getRestaurants()
        setRestaurants(data)
        setLoading(false)
      } catch (error) {
        console.error("Error fetching restaurants:", error)
        setLoading(false)
      }
    }

    fetchRestaurants()
  }, [])

  const handleChange = (event) => {
    const restaurantId = event.target.value
    setSelectedRestaurant(restaurantId)
    onSelectRestaurant(restaurantId)
  }

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#f5f5f5",
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        padding: "20px",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "30px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          maxWidth: "400px",
          width: "100%",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            marginBottom: "20px",
            textAlign: "center",
            fontWeight: "600",
            color: "#333",
          }}
        >
          Select Restaurant
        </Typography>
        <Typography
          variant="body2"
          sx={{
            marginBottom: "24px",
            textAlign: "center",
            color: "#666",
          }}
        >
          Choose a restaurant to continue
        </Typography>
        <FormControl fullWidth>
          <InputLabel id="restaurant-select-label">Restaurant</InputLabel>
          <Select
            labelId="restaurant-select-label"
            id="restaurant-select"
            value={selectedRestaurant}
            label="Restaurant"
            onChange={handleChange}
          >
            {restaurants.map((restaurant) => (
              <MenuItem key={restaurant.id} value={restaurant.id}>
                {restaurant.restaurant_name || `Restaurant #${restaurant.id}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  )
}
